import React from 'react';
import { motion } from 'framer-motion';
const CHECKOUT_URL = 'https://7vtxaf-x1.myshopify.com/cart/45821756342458:1';
export function Hero() {
  return <section className="w-full bg-white py-16 md:py-24 px-4" data-id="element-46">
      <div className="max-w-6xl mx-auto" data-id="element-47">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-48">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-black leading-tight mb-8" data-id="element-49">
            Dejá de Procrastinar y{' '}
            <span className="bg-yellow-400 px-2" data-id="element-50">Construí Disciplina Real</span>{' '}
            en 21 Días
          </h1>

          <motion.a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.3,
          duration: 0.5
        }} className="my-12 flex justify-center" data-id="element-51">
            <img src="https://cdn.magicpatterns.com/uploads/8oir4cejC94Ra5gXcAVHun/ChatGPT_Image_5_may_2026,_01_57_43_a.m..png" alt="Sistema completo de ebooks" className="w-full max-w-md md:max-w-lg cursor-pointer hover:scale-105 transition-transform duration-300" data-id="element-52" />
          </motion.a>

          <p className="text-xl md:text-2xl text-gray-700 mb-12 max-w-3xl mx-auto" data-id="element-53">
            Un sistema simple para dejar de postergar y crear hábitos que duran,
            incluso cuando no tenés ganas
          </p>

          <motion.a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="inline-block bg-orange-500 hover:bg-orange-600 text-white font-bold text-xl md:text-2xl px-12 py-6 rounded-xl shadow-2xl transition-all duration-300 w-full md:w-auto" data-id="element-54">
            QUIERO EMPEZAR AHORA
          </motion.a>

          <p className="text-sm text-gray-600 mt-4" data-id="element-55">
            Acceso inmediato • Pago único • Para empezar hoy
          </p>
        </motion.div>
      </div>
    </section>;
}